import { IcoLens } from 'icone';
import React, { useEffect, useState } from 'react';
import { Button, Modal, OverlayTrigger, Tab, Tabs, Tooltip } from 'react-bootstrap';
import { DeliverableOrMilestoneType } from 'lib/api_ts/continuosReportingApi';
import ContinuosReportingDeliverableUpdateForm from './ContinuosReportingDeliverableUpdateForm';
import ContinuosReportingMilestoneUpdateForm from './ContinuosReportingMilestoneUpdateForm';
import { getStreamsByProjectId, StreamType } from 'lib/api_ts/overviewApi';
import { useLocation } from 'react-router-dom-v5-compat';
import { getTaskPossibleStatuses, getUsersForResponsible, TaskStatusType, UserForResponsibleType } from 'lib/api_ts/responsibleApi';
import { getPartnersByProjectId } from 'lib/api_ts/parternshipApi';
import UploadDocument from 'components/form/upload/uploadDocuments';

interface ContinuosReportingInfoCellProps {
	data: DeliverableOrMilestoneType;
	value: string | number | undefined;
}

const ContinuosReportingInfoCell: React.FC<ContinuosReportingInfoCellProps> = ({ data }) => {
	const { pathname } = useLocation();

	const projectId = pathname.split('/')[2];
	const [isModalOpen, setIsModalOpen] = useState(false);

	const [streams, setStreams] = useState<StreamType[]>([]);
	useEffect(() => {
		if (!isModalOpen) return;
		(async () => {
			try {
				const streamsFromApi = await getStreamsByProjectId(projectId);
				setStreams(streamsFromApi);
			} catch (error) {
				console.error('Error fetching streams', error);
			}
		})();
	}, [projectId, isModalOpen]);
	const [possibleResponsibles, setPossibleResponsibles] = useState<UserForResponsibleType[]>([]);
	useEffect(() => {
		if (!isModalOpen) return;
		(async () => {
			try {
				const possibleResponsiblesFromApi = await getPartnersByProjectId(projectId);
				const usersForResponsiblesFromApi = await Promise.all(
					possibleResponsiblesFromApi.map((partner) => getUsersForResponsible(partner.company.id.toString())),
				);
				setPossibleResponsibles(usersForResponsiblesFromApi.flat());
			} catch (error) {
				console.error('Error fetching possibleResponsibles', error);
			}
		})();
	}, [projectId, isModalOpen]);

	const [taskStatus, setTaskStatus] = useState<TaskStatusType[]>([]);
	useEffect(() => {
		if (!isModalOpen) return;
		(async () => {
			try {
				const taskStatusFromApi = await getTaskPossibleStatuses();
				setTaskStatus(taskStatusFromApi);
			} catch (error) {
				console.error('Error fetching taskStatus', error);
			}
		})();
	}, [isModalOpen]);

	const createNameFromType = (type: 'M' | 'D') => {
		switch (type) {
			case 'D':
				return 'Deliverable';
			case 'M':
				return 'Milestone';
		}
	};

	const tabs = [
		{
			eventKey: 'details',
			title: 'Dettagli',
			content: (() => {
				switch (data.type) {
					case 'D':
						return (
							<ContinuosReportingDeliverableUpdateForm
								data={data}
								isModalOpen={isModalOpen}
								streams={streams}
								possibleResponsibles={possibleResponsibles}
								taskStatus={taskStatus}
							/>
						);
					case 'M':
						return (
							<ContinuosReportingMilestoneUpdateForm
								data={data}
								isModalOpen={isModalOpen}
								streams={streams}
								possibleResponsibles={possibleResponsibles}
								taskStatus={taskStatus}
							/>
						);
				}
			})(),
		},
		{
			eventKey: 'documents',
			title: 'Documenti',
			content: (
				<UploadDocument
					entity={'project' + createNameFromType(data.type) + 's'}
					entityId={data.id || ''}
					projectId={projectId}
					filterBySection=""
					disableDelete
					disableEdit
				/>
			),
		},
	];

	return (
		<>
			<OverlayTrigger placement="top" overlay={(props) => <Tooltip {...props}>Info</Tooltip>}>
				<Button
					variant="link"
					onClick={() => {
						setIsModalOpen(true);
					}}
				>
					<IcoLens className="edit" />
				</Button>
			</OverlayTrigger>
			<Modal size="lg" show={isModalOpen} onHide={() => setIsModalOpen(false)} centered>
				<Modal.Header closeButton>
					<Modal.Title>{createNameFromType(data.type)}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{/* Add your content here */}
					<Tabs className="mb-4" defaultActiveKey="details" fill>
						{tabs.map((tab) => (
							<Tab key={tab.eventKey} eventKey={tab.eventKey} title={tab.title}>
								{tab.content}
							</Tab>
						))}
					</Tabs>
				</Modal.Body>
				{/* <Modal.Footer>
          <Button variant="secondary" onClick={() => setIsModalOpen(false)}>
            Chiudi
          </Button>
        </Modal.Footer> */}
			</Modal>
		</>
	);
};

export default ContinuosReportingInfoCell;
